import React, { useState } from "react";
//import PropTypes from 'prop-types';

import Entries from "./../Entries";
import { FormContainer, FormLayout, OverlayForm } from "playground/cms/Form";
import OfferForm from "./OfferForm";
import { ListLayout } from "../../List";
import { useApiActions, usePending } from "state/hooks";
import { runSyncTask, syncData } from "cms/state/actions/integrations";
import { useSelector } from "react-redux";
import { selectEntity } from "state/selectors/data";
import DateDiff from "components/DateDiff";
import { ResourceForm } from "../Resources";
import { SyncTaskForm } from "./../SyncTasks";
import Popover from "components/Popover";
import SelectList, { SelectListItem } from "playground/ui/SelectList";
import { CircularProgress } from "@material-ui/core";
import SyncTasksForm from "../SyncTasks/SyncTasksForm";

function selectSyncTask(store, type) {
    const tasks = store.data?.["cms.sync-tasks"] || {};
    const active = Object.values(tasks).filter((task) => {
        return task.active;
    });
    const task = active[0];
    if (!task) return {};
    const integration = selectEntity(
        store,
        "cms.integrations",
        task.integration
    );
    return { task, integration };
}

function ListSyncTask(props) {
    const { task, integration } = useSelector((store) =>
        selectSyncTask(store, "offers")
    );
    const { onSyncData, onRunSyncTask } = useApiActions({
        onSyncData: syncData,
        onRunSyncTask: runSyncTask,
    });

    const [showTask, setShowTask] = useState(false);
    const closeTask = () => setShowTask(false);
    const runSync = () => onRunSyncTask(task.id, props.type);

    const isPending = usePending(task?.id);

    if (!task) return null;

    return (
        <>
            <Popover
                trigger={({ onClick }) => (
                    <div onClick={onClick}>
                        {isPending ? (
                            <CircularProgress
                                color={"inherit"}
                                size={20}
                                thickness={4.2}
                            />
                        ) : (
                            <>
                                {integration?.type} {props.list}
                                <DateDiff value={task.synced_at} />
                            </>
                        )}
                    </div>
                )}
                content={({ onClose }) => (
                    <SelectList onClick={onClose}>
                        <SelectListItem onClick={() => runSync()}>
                            Synchronizuj teraz
                        </SelectListItem>
                        <SelectListItem onClick={() => setShowTask(true)}>
                            Ustawienia synchronizacji
                        </SelectListItem>
                    </SelectList>
                )}
            />
            <OverlayForm open={showTask && task} onClose={closeTask}>
                {task && (
                    <ResourceForm
                        type={"cms.sync-tasks"}
                        id={task.id}
                        onClose={closeTask}
                    >
                        <FormLayout>
                            <FormLayout.Content replace={true}>
                                <FormLayout.Tab
                                    id={"sync-task"}
                                    label={"Ustawienia synchronizacji"}
                                >
                                    <SyncTasksForm />
                                </FormLayout.Tab>
                            </FormLayout.Content>
                        </FormLayout>
                    </ResourceForm>
                )}
            </OverlayForm>
        </>
    );
}

export function Offers(props) {
    const { type } = props;

    const { task, integration } = useSelector((store) =>
        selectSyncTask(store, "offers")
    );
    const { onSyncData, onRunSyncTask } = useApiActions({
        onSyncData: syncData,
        onRunSyncTask: runSyncTask,
    });

    const [showTask, setShowTask] = useState(false);
    const closeTask = () => setShowTask(false);
    const runSync = () => onRunSyncTask(task.id, type);

    return (
        <>
            <Entries {...props}>
                <ListLayout>
                    <ListLayout.Header>
                        <ListLayout.Header.Addon>
                            <ListSyncTask {...props} />
                        </ListLayout.Header.Addon>
                    </ListLayout.Header>
                </ListLayout>
                <FormLayout>
                    <FormLayout.Content prepend={true}>
                        <FormLayout.Tab id={"offer"} label={"Oferta"}>
                            <OfferForm {...props} />
                        </FormLayout.Tab>
                    </FormLayout.Content>
                </FormLayout>
            </Entries>
        </>
    );
}

Offers.propTypes = {};

Offers.defaultProps = {};

export default Offers;
